import { render, staticRenderFns } from "./scheduling.vue?vue&type=template&id=024b81a2&scoped=true&"
import script from "./scheduling.vue?vue&type=script&lang=js&"
export * from "./scheduling.vue?vue&type=script&lang=js&"
import style0 from "./scheduling.vue?vue&type=style&index=0&id=024b81a2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "024b81a2",
  null
  
)

export default component.exports